import { DateFilterComponent } from './SimpleDate.Component';
import { Statistics, StatisticsData } from './../../@core/interfaces/portal/statistics';
import { Device } from './../../@core/interfaces/portal/devices';
import { Component, OnInit } from '@angular/core';
import { UserActivityService } from '../../@core/backend/portal/services/user-activity.service';
import { NbAccessChecker } from '@nebular/security';
import { takeUntil} from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DataSource } from 'ng2-smart-table/lib/lib/data-source/data-source';
import { DatePipe } from '@angular/common';
import { DateTime } from "luxon";
import { UserData } from '../../@core/interfaces/common/users';
import { environment } from '../../../environments/environment';
import { saveAs } from 'file-saver';
import { NbToastrService } from '@nebular/theme';

@Component({
  selector: 'ngx-ecommerce',
  styleUrls: ['./e-commerce.component.scss'],
  templateUrl: './e-commerce.component.html',
  
})
export class ECommerceComponent implements OnInit {

  protected readonly unsubscribe$ = new Subject<void>();
  public statistics: Statistics;
  public statisticsData: StatisticsData;
  private distinctiOneMonth = '';
  private distinctiThreeMonth = '';
  private distinctiTwoMonth = '';
  private geralOneMonth = '';
  private geralThreeMonth = '';
  private geralTwoMonth = '';
  public userActivity: any[];
  editUser: boolean;
  source: DataSource;
  sourceUser: DataSource;
  ListUser: any;
  ListUserLogados: any;
  NaoLogados: Number;
  JaLogados: Number;

  settings = {
    noDataMessage: 'Nenhum log foi encontrado.',
    mode: 'external',
    actions: {
      add: false,
      delete: false,
      edit: false,
    },
    columns: {
      userId: {
        title: 'ID Usuário',
        type: 'int',
        width: '8%',
      },
      username: {
        title: 'Nome',
        type: 'string',
        width: '12%',
      },
      date: {
        title: 'Data',
        type: 'string',
        filter: {
          type: 'custom',
          component: DateFilterComponent
        },
        valuePrepareFunction: (element) => {
          return new DatePipe('en-US').transform(element, 'dd/MM/yyyy hh:mm');
        },
      },
      url: {
        title: 'Função',
        type: 'string',
        width: '12%',
      },
      typeRegister: {
        title: 'Tipo',
        type: 'string',
        width: '12%',
      },
      codRegister: {
        title: 'Chave',
        type: 'string',
        width: '8%',
      },
      description: {
        title: 'Descrição',
        type: 'string',
      },
    },
  };

  settingsUser = {
    noDataMessage: 'Nenhum usuário foi encontrado.',
    mode: 'external',
    actions: {
      add: false,
      edit: false,
      delete: false,
    },
    columns: {
      firstName: {
        title: 'Nome',
        type: 'string',
      },
      lastName: {
        title: 'Sobrenome',
        type: 'string',
      },
      login: {
        title: 'Usuário',
        type: 'string',
      },
      email: {
        title: 'Email',
        type: 'string',
      },
      groupCod: {
        title: 'Grupo',
      },
      codProviderIntegration: {
        title: 'Cód Integração',
        type: 'string',
        filter: true,
      },
      provider: {
        title: 'Fornecedor',
        type: 'string',
        filter: true,
      }
    },
  };

  settingsUserLogados = {
    noDataMessage: 'Nenhum usuário foi encontrado.',
    mode: 'external',
    actions: {
      add: false,
      edit: false,
      delete: false,
    },
    columns: {
      firstName: {
        title: 'Nome',
        type: 'string',
      },
      lastName: {
        title: 'Sobrenome',
        type: 'string',
      },
      login: {
        title: 'Usuário',
        type: 'string',
      },
      email: {
        title: 'Email',
        type: 'string',
      },
      groupCod: {
        title: 'Grupo',
      },
      codProviderIntegration: {
        title: 'Código Integração',
        type: 'string',
        filter: true,
      },
      provider: {
        title: 'Fornecedor',
        type: 'string',
        filter: true,
      },
      lastAccess: {
        title: 'Último Acesso',
        type: 'string',
        filter: false,
        valuePrepareFunction: (element) => {
          return new DatePipe('en-US').transform(element, 'dd/MM/yyyy HH:mm:ss');
        },
      }
    },
  };

  constructor(
    private userActivityService: UserActivityService,
    private toastrService: NbToastrService,
    private accessChecker: NbAccessChecker
  ) { 
    this.editUser = false;
    this.source = this.userActivityService.gridDataSource;
  }

  async ngOnInit(): Promise<void> {
    const t = await this.userActivityService.getStatistics().toPromise();
    this.statistics = t;
    this.distinctiOneMonth = String(this.statistics.distinctUser.oneMonth);
    this.distinctiThreeMonth = String(this.statistics.distinctUser.threeMonth)
    this.distinctiTwoMonth = String(this.statistics.distinctUser.twoMonth)
    this.geralOneMonth = String(this.statistics.general.oneMonth);
    this.geralThreeMonth = String(this.statistics.general.threeMonth)
    this.geralTwoMonth = String(this.statistics.general.twoMonth)
    this.VerifyUser();
    this.SetIndicator();
    this.loadData();
  }

  loadData() {
    //Coleta os dados dos usuários não logados
    this.userActivityService.listarUsuarios(1, 5000, false)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((registerData) => {
        this.ListUser  = registerData['items'];
        this.NaoLogados  = Number(registerData['totalCount'])
      });

      //Coleta os dados dos usuários logados
      this.userActivityService.listarUsuarios(1, 5000, true)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((registerData) => {
        this.ListUserLogados  = registerData['items'];
        this.JaLogados  = Number(registerData['totalCount'])
      });
  }

  private SetIndicator() {
    this.userActivity =  [
      {
        days: '30',
        count: this.distinctiOneMonth
      },
      {
        days: '60',
        count: this.distinctiThreeMonth
      },
      {
        days: '90',
        count: this.distinctiTwoMonth
      }
    ];
  }

  private VerifyUser() {
    const checkEdit = this.accessChecker.isGranted('edit', 'perfil');
    checkEdit
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result) => {
        this.editUser = result;
      });
  }

  refreshData() {
    this.source = this.userActivityService.gridDataSource;
  }

  changeTab(selectedTab) {
    if (selectedTab.tabTitle === 'Acessos') {
     // this.profitChart && this.profitChart.resizeChart();
    } else {
      //this.ordersChart && this.ordersChart.resizeChart();
    }
  }

  /*
  exportCotacao () {
    const observable = this.userActivityService.downLoggedList();
    observable
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(objReturn => {
        this.toastrService.success('Sucesso', 'Arquivo exportado com sucesso');
        const name = `${environment.fileUrl}/v1/files/` + objReturn.fileDownloadName;
        saveAs(name);

      //  const urlBase = environment.apiUrl.replace('api', '').concat('v1/files/').concat(objReturn.fileDownloadName);
      // saveAs(urlBase.toString());
    }, error => {
      this.tratarErros(error);
    });
  }
  */
  
  private tratarErros(erros) {
    const erro = erros.error.errors;

    if (erro === undefined) {
      this.toastrService.danger('', erros.error.error, {duration: 10000});
    } else {
      Object.entries(erro).forEach(([key]) => {
        let value = erro[key];
        value.forEach(element => {
          this.toastrService.danger('', element, {duration: 10000});
        });
      });
    }
  }
}
